import gql from 'graphql-tag';

export const GET_AFTERMARKET_PRODUCT_DOCUMENTS = gql`
  query GetAftermarketProductDocuments($aftermarketProductId: ID!) {
    aftermarketProductDocuments(aftermarketProductId: $aftermarketProductId) {
      documentId
      aftermarketProductId
      docName
      source
    }
  }
`;
